export default __webpack_public_path__ + "static/media/design_review.044fc61c.svg";